module.exports = __webpack_public_path__ + "img/graphic-you-are-here.e1ba8518.png";